<div class="view-container">
  <div class="renderers">
    <mat-card>
      <mat-card-content>
        <div class="mat-card-content-label" fxLayoutAlign="space-between center" fxLayout="row" fxLayoutGap="0px" fxLayoutGap.lt-sm="15px" fxLayout.lt-sm="column">
          <label>Recipe Event Summaries</label>
        </div>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-card-content fxLayoutAlign="start center" fxLayout="column">
            <div class="filter w-100" fxFlex="100" fxLayoutAlign="center center" fxLayout="row" fxLayoutGap="15px" fxLayout.lt-sm="column">
              <mat-form-field class="accent">
                <mat-label>Search recipe event summaries</mat-label>
                <input matInput type="text" [(ngModel)]="searchTerm" (keyup.enter)="loadRecipeEventSummaries()"
                  (keyup.esc)="searchTerm=''; loadRecipeEventSummaries()" name="searchTerm" placeholder="Search Name">
                <button mat-button *ngIf="searchTerm" matSuffix mat-icon-button aria-label="Clear"
                  (click)="searchTerm=''; loadRecipeEventSummaries()">
                  <mat-icon>close</mat-icon>
                </button>
              </mat-form-field>
              <div fxLayout="row" fxLayoutGap="10px">
                <button type="submit" mat-flat-button color="primary" (click)="loadRecipeEventSummaries()" matTooltip="Search"
                  [class.button-spinner]="loading" [disabled]="loading">
                  <mat-icon>search</mat-icon> Search
                </button>
              </div>
            </div>
            <div class="m-b-20 w-100" fxLayout="column" fxLayoutAlign="start start">
              <div class="w-100" fxFlex="100" fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="5px">
                <small class="text-info"><i>filter:</i></small>
                <mat-chip-list #optionChipList>
                  <mat-chip color="accent">
                    <span>{{ selectedCompany?.code }}</span>
                    <button matChipRemove (click)="toggleCompanyFilter()">
                      <mat-icon *ngIf="companyFilter" color="primary" matTooltip="Clear filter">clear</mat-icon>
                      <mat-icon *ngIf="!companyFilter">filter_alt</mat-icon>
                    </button>
                  </mat-chip>
                  <mat-chip *ngIf="productNameFilter || productNameFilter === 0" color="accent">
                    <span>{{ productName[productNameFilter] }}</span>
                    <button matChipRemove (click)="clearFilter(ProductParamName)">
                      <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                    </button>
                  </mat-chip>
                  <mat-chip *ngIf="statusNameFilter || statusNameFilter === 0" color="accent">
                    <span>{{ statusName[statusNameFilter] }}</span>
                    <button matChipRemove (click)="clearFilter(StatusParamName)">
                      <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                    </button>
                  </mat-chip>
                  <mat-chip *ngIf="searchTerm" color="accent">
                    <span>Search {{ searchTerm }}</span>
                    <button matChipRemove (click)="clearFilter(FilterParamName)">
                      <mat-icon color="primary" matTooltip="Clear filter">clear</mat-icon>
                    </button>
                  </mat-chip>
                </mat-chip-list>
              </div>
              <mat-chip-list class="m-t-20 w-100" *ngIf="!productNameFilter && productNameFilter !== 0" #optionChipList>
                <mat-chip *ngFor="let product of productName | enumKeyValue:'asc'" color="accent">
                  <span>{{ productName[product.value] }}</span>
                  <button matChipRemove (click)="setProductFilter(product.value)">
                    <mat-icon>filter_alt</mat-icon>
                  </button>
                </mat-chip>
              </mat-chip-list>
            </div>
          </mat-card-content>
        </mat-card>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}" class="contrast">
          <mat-card-content class="w-100" fxLayout="column" fxLayoutAlign="center start">
            <div class="card-title w-100" fxFlex="100" fxLayout="row" fxLayoutAlign="space-between center" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start">
              <span fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start start">
                <strong>Summary</strong> <small *ngIf="dataSource?.data?.length > 0"><i><span class="text-info">{{ viewControls.pageSize }}</span> renders <span class="text-info">{{ dataSource.data[0]?.dateAdded | date:'medium' }}</span> ~ <span class="text-info">{{ dataSource.data[dataSource.data.length - 1]?.dateAdded | date:'medium' }}</span></i></small>
              </span>
            </div>
            <div class="w-100" fxLayout="column" fxLayoutAlign="start center" fxFlex="100">
              <mat-card class="mat-card-inline-sm w-100 banner-info card-link" fxFlex="100" (click)="filterStatus(statusName.InProgress)">
                <mat-card-content>
                  <div class="card-title m-b-10" fxLayout="row" fxLayoutAlign="space-between center">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px"><mat-icon class="text-info">pending</mat-icon><span class="text-info">{{ inProgressSummaries?.length }} in progress</span><i *ngIf="inProgressSummaries?.length > 0">on</i></div>
                  </div>
                  <div fxLayout="row" fxLayoutAlign="start center">
                    <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="10px">
                      <ng-container *ngFor="let summary of inProgressSummaries">
                        <span *ngIf="summary?.rendererName" class="link" matTooltip="{{ productName[summary?.productName] }} running since {{ summary?.dateStarted | date:'medium' }}" 
                          (click)="viewDetail(summary.artifactId);"
                          [ngStyle]="{ 'color': getProductColour(summary?.productName) }">{{ summary?.rendererName }}</span>
                      </ng-container>
                    </div>
                  </div>
                </mat-card-content>
              </mat-card>
              <div class="w-100" fxLayout="row" fxLayoutAlign="space-between center" fxFlex="100" fxLayoutGap="10px" fxLayout.lt-md="column" fxLayoutAlign.lt-md="start center">
                <mat-card class="mat-card-inline-sm banner-primary card-link" fxFlex="0 1 calc(33.33% - 10px)" fxFlex.lt-md="100%" [ngClass.lt-md]="{'w-100': true}" (click)="filterStatus(statusName.Queued)">
                  <mat-card-content>
                    <div class="card-title" fxLayout="row" fxLayoutAlign="space-between center">
                      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px"><mat-icon class="text-muted">pending</mat-icon><span class="text-muted">{{ queuedSummaries?.length }} queued</span></div>
                    </div>
                  </mat-card-content>
                </mat-card>
                <mat-card class="mat-card-inline-sm banner-error card-link" fxFlex="0 1 calc(33.33% - 10px)" fxFlex.lt-md="100%" [ngClass.lt-md]="{'w-100': true}" (click)="filterStatus(statusName.Failed)">
                  <mat-card-content>
                    <div class="card-title" fxLayout="row" fxLayoutAlign="space-between center">
                      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px"><mat-icon class="text-danger">error</mat-icon><span class="text-danger">{{ errorSummaries?.length }} have errors</span></div>
                    </div>
                  </mat-card-content>
                </mat-card>
                <mat-card class="mat-card-inline-sm banner-success card-link" fxFlex="0 1 calc(33.33% - 10px)" fxFlex.lt-md="100%" [ngClass.lt-md]="{'w-100': true}" (click)="filterStatus(statusName.Complete)">
                  <mat-card-content>
                    <div class="card-title" fxLayout="row" fxLayoutAlign="space-between center">
                      <div fxLayout="row" fxLayoutAlign="start center" fxLayoutGap="4px"><mat-icon class="text-success">check_circle</mat-icon><span class="text-success">{{ completeSummaries?.length }} completed</span></div>
                    </div>
                  </mat-card-content>
                </mat-card>
              </div>
            </div>
          </mat-card-content>
        </mat-card>
        <recipe-event-summary-card *ngFor="let item of dataSource.data"
          [recipeEventSummary]="item"
          [searchTerm]="searchTerm"
          [showRenderer]="true">
        </recipe-event-summary-card>
        <mat-card [ngClass.lt-sm]="{'mat-card-inline-sm': true}">
          <mat-paginator [length]="viewControls.totalItems" [pageSize]="viewControls.pageSize"
            [pageIndex]="viewControls.pageIndex" [pageSizeOptions]="viewControls.pageSizeOptions"
            (page)="onPageChange($event)">
          </mat-paginator>
        </mat-card>
      </mat-card-content>
    </mat-card>
  </div>
</div>